import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from './base/api.service';
import { ApiEndpointsService } from './base/api-endpoints.service';
import { Company } from '../interfaces/info/company';
import { ServerResponse } from '../interfaces/base/server.response';

@Injectable()

export class CompanyService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<Company[] | boolean> {
    return new Observable<Company[] | boolean>((o: Subscriber<Company[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('companies.index'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<Company[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(id: number): Observable<Company | boolean> {
    return new Observable<Company | boolean>((o: Subscriber<Company | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('companies.read', {':id': id}))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<Company>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  export(): Observable<ServerResponse> {
    return this.api.get(this.apiEndpoints.get('companies.export'));
  }
}
